module.exports = __webpack_public_path__ + "img/fossilImg3.3241d34b.jpg";